import React from 'react'
import OrganizationIntegrations from 'src/app/OrganizationIntegrations/OrganizationIntegrations'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { orgIntegrationsRouteProps } from 'src/navigation/routeProps'

const OrganizationIntegrationsAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsIntegrations,
  routeProps: orgIntegrationsRouteProps,
  component: <OrganizationIntegrations />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default OrganizationIntegrationsAppRoute
